import { CustomerPaymentPreferencesApiRemoteService } from '../../Services/api/customer-payment-preferences/customer-payment-preferences-service'
import { IDestroyCustomerPaymentPreferencePayload } from '../../Services/api/customer-payment-preferences/customer-payment-preferences.interface'    
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyCustomerPaymentPreferencesUseCase
implements IFormUsecase<IDestroyCustomerPaymentPreferencePayload, void> {
  constructor (private readonly CustomerPaymentPreferencesApi: CustomerPaymentPreferencesApiRemoteService) {}
    

  public async handle (
    data: IDestroyCustomerPaymentPreferencePayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CustomerPaymentPreferencesApi.destroy(data)

      if (response.isFailure) {
        return response
      }
    
      
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
